import React from "react";
import { ChevronDown } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

interface FilterMultiSelectOption {
  value: string;
  label: string;
}

interface FilterMultiSelectProps {
  placeholder: string;
  options: FilterMultiSelectOption[];
  value: string[];
  onValueChange: (value: string[]) => void;
  className?: string;
  disabled?: boolean;
}

export const FilterMultiSelect: React.FC<FilterMultiSelectProps> = ({
  placeholder,
  options,
  value,
  onValueChange,
  className,
  disabled = false,
}) => {
  const handleOptionChange = (optionValue: string) => {
    const nextValue = value.includes(optionValue)
      ? value.filter((item) => item !== optionValue)
      : [...value, optionValue];

    onValueChange(nextValue);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={disabled}>
        <Button
          type="button"
          variant="new_outline"
          className={className}
          disabled={disabled}
        >
          <span className="truncate">{placeholder}</span>
          {value.length > 0 ? (
            <Badge variant="number_secondary">{value.length}</Badge>
          ) : null}
          <ChevronDown />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="min-w-[var(--radix-dropdown-menu-trigger-width)]"
      >
        <DropdownMenuGroup>
          {options.map((option) => (
            <DropdownMenuCheckboxItem
              key={option.value}
              checked={value.includes(option.value)}
              onCheckedChange={() => handleOptionChange(option.value)}
              onSelect={(event) => event.preventDefault()}
            >
              {option.label}
            </DropdownMenuCheckboxItem>
          ))}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
